export function handle(type, data) {
  if(window.umami){
    switch (type) {
      case 'state:started':
        umami.track('qcm_start', { qcm_type: data.type, qcm_id: data.id });
        break;
      case 'state:complete':
        umami.track('qcm_complete', { qcm_type: data.type, qcm_id: data.id });
        break;
       case 'state:progress':
        if(data.questions_answered % 10 === 0){
          umami.track('qcm_progress', { qcm_type: data.type, qcm_id: data.id, questions_answered: String(data.questions_answered) });
        }
        break;
    }
  }
}
